import { Dispatch, SetStateAction, useState } from 'react';

type UseFilterAndSorting = (
  deps: any[],
  sorts: any[],
  isFuzzy: boolean,
  setIsFuzzy: Dispatch<SetStateAction<boolean>>,
) => {
  onChangeKeyword: (value: string | string[]) => void;
  onRemoveKeyword: (k: string) => void;
  onChangeToExactMatch: (from: string, to: string) => void;
  onChangeToFuzzyMatch: (from: string, to: string) => void;
  onReset: () => void;
};

export const useSearchMode = (
  initialFuzzy: boolean,
  useFilterAndSortingHook: UseFilterAndSorting,
) => {
  const [isFuzzySearch, setIsFuzzySearch] = useState<boolean>(initialFuzzy);

  const {
    onChangeKeyword,
    onRemoveKeyword,
    onChangeToExactMatch,
    onChangeToFuzzyMatch,
    onReset,
  } = useFilterAndSortingHook([], [], isFuzzySearch, setIsFuzzySearch);

  const onSearchTypeChange = () => {
    if (isFuzzySearch) {
      onChangeToExactMatch('name.regexp', 'name.list');
      setIsFuzzySearch(false);
    } else {
      onChangeToFuzzyMatch('name.list', 'name.regexp');
      setIsFuzzySearch(true);
    }
  };

  return {
    isFuzzySearch,
    onSearchTypeChange,
    onChangeKeyword,
    onRemoveKeyword,
    onReset,
  };
};

export default useSearchMode;
